export default "__VITE_ASSET__CPuwPn_R__"